export default "__VITE_ASSET__BfhOgrWg__"